import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import PalletRebuildColumn from './PalletRebuildColumn';
import React from "react";
import ExpandedPalletRebuild from "./ExpandedPalletRebuild";


const PalletRebuild = () => {
    const [columns] = PalletRebuildColumn();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>بازسازی</Title>

                </div>

            </ComponentCard> <ComponentCard>

            <CreatorTable
                expandable={{
                    expandedRowRender: (row) => (

                        <ExpandedPalletRebuild item={row}/>

                    ),
                }}


                columns={columns} listAddress='Pallet'/>

        </ComponentCard></div>
    );
};


export default PalletRebuild;